import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/physical-test-pack/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/physical-test-pack',
  name: 'physical_test_pack',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体测装备加油包',
    needOpenidUnderWechat: true,
  },
}

export default [indexRoute]
